
<tr :data-hover="hover" :data-clickable="clickable" :data-blink="blink">
	<slot />
</tr>
